import { Component, OnInit } from '@angular/core';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

@Component({
  selector: 'app-msal-silent-redirect',
  template: '<p>Processing authentication...</p>',
})
export class MsalSilentRedirectComponent implements OnInit {
  public ngOnInit(): void {
    void broadcastResponseToMainFrame().catch(() => {
      // Empty response is expected when opening the route manually.
    });
  }
}
